// Legacy Loader component

import React from "react";
import "./index.scss";

export default function Loading() {
  return (
    <div className='legacy-loading fill'>
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
